import { Autocomplete, Box, Chip, TextField, useTheme } from '@mui/material'
import FlexRow from 'components/ui/flex-row'
import FlexTypography from 'components/ui/flex-typography'
import { useState } from 'react'
import { useSnackbarContext } from '../../context/SnackbarProvider/SnackbarProvider'
import { renderColorByString } from '../DataGrid/renderColorByString'

interface DealsAutocompleteProps {
  multiple?: boolean
  deals: any
  label: any
  selectedDeal?: any
  setSelectedDeal?: any
  onAddDeal: any
  onClearDeal: () => void
  isDisabled?: boolean
  error?: boolean
  value?: any
}

const DealsAutocomplete = ({
  multiple = true,
  deals,
  label,
  selectedDeal,
  setSelectedDeal,
  onAddDeal,
  onClearDeal,
  isDisabled = false,
  error = false,
  value,
}: DealsAutocompleteProps) => {
  const theme = useTheme()
  const { showSnackbar } = useSnackbarContext()
  const [dialogOpen, setDialogOpen] = useState(false)
  const [tempInput, setTempInput] = useState('')
  const themeColor = theme.palette.mode === 'dark' ? 'white' : 'black'

  const handleOpenDialog = inputValue => {
    setTempInput(inputValue)
    setDialogOpen(true)
  }

  const handleCloseDialog = () => {
    setDialogOpen(false)
    setTempInput('')
  }

  const handleAddDeal = (event, newDeal) => {
    if (newDeal) {
      onAddDeal(newDeal)
    } else {
      onAddDeal(null)
    }
    handleCloseDialog()
  }
  // const handleRemoveDeal = dealId => {
  //   const newSelectedDeal = selectedDeal?.deal_uuid !== dealId
  //   setSelectedDeal(newSelectedDeal)
  // }

  const filterOptions = (options, { inputValue }) => {
    let filtered = options.filter(option => option.name.toLowerCase().includes(inputValue.toLowerCase()))
    if (inputValue !== '' && !filtered.some(option => option.name.toLowerCase() === inputValue.toLowerCase())) {
      filtered.unshift({
        inputValue,
        specialOption: true,
        id: `add-new-${inputValue}`,
      })
    }
    return filtered
  }
  const disabledStatuses = ['Ended', 'Ended (system)', 'Cancelled', 'Replaced']

  return (
    <>
      <Autocomplete
        multiple={false}
        value={selectedDeal || {}}
        id="deals-autocomplete"
        options={deals}
        onChange={(event, newValue) => handleAddDeal(event, newValue)}
        getOptionLabel={option => option.name || ''}
        // filterOptions={filterOptions}
        // renderOption={renderOption}
        getOptionDisabled={option => {
          if (option?.successorId) return true
          // return disabledStatuses.includes(option?.dealStatus)
        }}
        renderOption={(props, option) => {
          const { key, id, ...rest } = props as any
          return (
            <FlexRow component="li" key={`${key}-${id}`} justify="space-between" {...rest}>
              <FlexTypography grow={2} sx={{ fontSize: 14 }}>
                {option?.name}
              </FlexTypography>

              <FlexTypography flex={1} sx={{ fontSize: 14, fontStyle: 'italic', color: 'text.secondary' }}>
                {option?.successorId ? 'Has Successor' : null}
              </FlexTypography>

              <FlexTypography flex={1} sx={{ fontSize: 14, color: renderColorByString(option?.dealStatus) }}>
                {option?.dealStatus}
              </FlexTypography>
            </FlexRow>
          )
        }}
        renderTags={(tagValue, getTagProps) =>
          tagValue.map((option, index) => {
            const { key, ...rest } = getTagProps({ index })
            if (!option) {
              return null
            }
            return (
              <Box key={option.deal_uuid}>
                <Chip
                  key={key}
                  label={option?.name}
                  {...rest}
                  onDelete={() => onClearDeal()}
                  size="small"
                  style={{
                    height: 'auto',
                    width: 'auto',
                    borderColor: themeColor,
                    borderWidth: '0.5px',
                    borderStyle: 'solid',
                    backgroundColor: 'transparent',
                    color: themeColor,
                    borderRadius: '4px',
                    marginRight: '8px',
                  }}
                />
              </Box>
            )
          })
        }
        renderInput={params => (
          <TextField
            {...params}
            error={error}
            label={isDisabled ? 'Deal to be cloned' : label}
            sx={{
              '& .Mui-disabled': { color: 'text.secondary' },
              '& .MuiInputBase-input': {
                color: selectedDeal ? 'text.subtask' : 'inherit',
              },
              '& .MuiInputBase-input.Mui-disabled': {
                color: theme.palette.text.secondary, // 👈 text color when disabled
                WebkitTextFillColor: theme.palette.text.secondary, // 👈 required for Safari
              },
              '& .MuiInputBase-root.Mui-disabled': {
                color: theme.palette.text.secondary, // 👈 icon/button/etc color
                bgcolor: theme.palette.background.defaultdim,
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: isDisabled ? theme.palette.text.secondary : undefined, // 👈 optional border color
              },
            }}
          />
        )}
        // renderInput={params => <TextField {...params} label={label} />}
        fullWidth
        disabled={isDisabled}
        freeSolo
      />
    </>
  )
}

export default DealsAutocomplete
